import React from 'react'

const EventItem = ({
  active,
  hour,
  availability,
  showAvailability,
  eventRenderMode,
  eventData,
  onEventSelected
}) => {
  const { show_time, description } = eventData

  const OnlyTime = () => (
    <>
      <strong className="text-white me-2">
        <i className="far fa-clock me-1" aria-hidden="true"></i>
        {show_time === true ? hour : description}
      </strong>
      {showAvailability !== 'no_show_availability' && (
        <span className="badge bg-white text-primary">
          <i className="fas fa-ticket-alt me-1" aria-hidden="true"></i>
          {availability}
        </span>
      )}
    </>
  )

  const WithDescription = () => (
    <span className="d-flex justify-content-between align-items-center">
      {description && <span className="text-white">{description}</span>}
      <strong className="text-white me-3">
        <i className="far fa-clock me-1" aria-hidden="true"></i>
        <span className="me-2">{hour}</span>
        {showAvailability !== 'no_show_availability' && (
          <span className="badge bg-white text-primary">
            <i className="fas fa-ticket-alt me-1" aria-hidden="true"></i>
            {availability}
          </span>
        )}
      </strong>
    </span>
  )

  const activeClass = active ? ' active' : ''

  return (
    <div className="p-2">
      <button
        onClick={() => onEventSelected(eventData)}
        type="button"
        className={`btn btn-primary w-100${activeClass}`}
        disabled={availability <= 0}
      >
        {eventRenderMode === 'description' ? (
          <WithDescription />
        ) : (
          <OnlyTime />
        )}
      </button>
    </div>
  )
}

export default EventItem
